<app-layout-crud-index
  [titulo]="title"
  [length]="length"
  [dataSource]="dataSource"
  [filterFields]="filterFields"
  [configColumns]="configColumns"
  [displayedColumns]="displayedColumns"
  (onChangePage)="changePage($event)"
  (onFilter)="filter($event)"
  (onSubmitAdvancedFilter)="submitAdvancedFilter($event)"
  (onOpenShow)="openShow($event)"
  (onOpenNew)="openNew($event)"
  (onOpenEdit)="openEdit($event)"
  (onOpenDelete)="openDelete($event)"
  (onResetFilter)="resetFilter()"

>
  <table-responsive
    table
    [length]="length"
    (changePage)="changePage($event)"
    (filter)="filter($event)"
    [displayedColumns]="displayedColumns"
    [dataSource]="dataSource"
    [configColumns]="configColumns"
    (openShow)="openShow($event)"
    (openNew)="openNew($event)"
    (openEdit)="openEdit($event)"
    (openDelete)="openDelete($event)"
    (onSelectionChange)="onSelectionChange($event)"
    [currentTab]="currentTab"
    [userType]="userType"
    [isEditableShow]="permissionService.is(permissionService.systemActionRoles.SYSTEM_MODULE_EDIT_BUTTON_SHOW)"
    [isEditableEnabled]="permissionService.is(permissionService.systemActionRoles.SYSTEM_MODULE_EDIT_BUTTON_ENABLED)"

    [isDeletableShow]="permissionService.is(permissionService.systemActionRoles.SYSTEM_MODULE_DELETE_BUTTON_SHOW)"
    [isDeletableEnabled]="permissionService.is(permissionService.systemActionRoles.SYSTEM_MODULE_DELETE_BUTTON_ENABLED)"
  ></table-responsive>
  <div footer>
    <div fxFlex fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4">
      <div fxFlex></div>
      <div fxFlex>
        <button disabled class="action-button" mat-raised-button></button>
      </div>
      <div fxFlex>
        <button disabled class="action-button" mat-raised-button></button>
      </div>
      <div fxFlex>
        <button disabled class="action-button" mat-raised-button></button>
      </div>
      <div fxFlex></div>
    </div>
  </div>
</app-layout-crud-index>
